webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetalMarketHeader_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Announcement_vue__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__MetalMarketHeader_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__Announcement_vue__["a"]; });











/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pricing; });
var pricing = {
  methods: {
    priceItem: function priceItem(spotPriceData, itemData) {
      var itemBid = null;
      var itemAsk = null;

      var dataCheck = true;

      var weigthOz = parseFloat(itemData.WC_OZWT);
      var bidPremium = parseFloat(itemData.premium_bid);
      var askPremium = parseFloat(itemData.premium_ask);

      if (typeof weigthOz === 'undefined' || weigthOz == null) {
        console.log('MISSING WEIGHT');
        dataCheck = false;
      }
      if (typeof bidPremium === 'undefined' || bidPremium == null) {
        console.log('MISSING BID PREMIUM');
        dataCheck = false;
      }
      if (typeof askPremium === 'undefined' || askPremium == null) {
        console.log('MISSING ASK PREMIUM');
        dataCheck = false;
      }

      if (typeof itemData.use_percent === 'undefined' || itemData.use_percent == null) {
        console.log('MISSING PERCENT FLAG');
        dataCheck = false;
      }
      if (typeof itemData.melt_plus === 'undefined' || itemData.melt_plus == null) {
        console.log('MISSING MELT FLAG');
        dataCheck = false;
      }
      if (typeof itemData.pricing_type === 'undefined' || itemData.pricing_type == null) {
        console.log('MISSING PRICING TYPE');
        dataCheck = false;
      }

      var pricingType = itemData.pricing_type;

      if (spotPriceData) {
        var currentSpotPrice = spotPriceData[pricingType];

        if (currentSpotPrice) {
          if (typeof currentSpotPrice.bid === 'undefined' || currentSpotPrice.bid == null) {
            console.log('MISSING SPOT BID');
            dataCheck = false;
          }
          if (typeof currentSpotPrice.ask === 'undefined' || currentSpotPrice.ask == null) {
            console.log('MISSING SPOT ASK');
            dataCheck = false;
          }
        } else {
          if (pricingType !== 'FIX') {
            console.log('MISSING SPOT PRICE DATA');
            dataCheck = false;
          }
        }

        if (dataCheck) {
          if (pricingType === 'FIX') {
            itemBid = bidPremium;
            itemAsk = askPremium;
          } else {
            if (currentSpotPrice) {
              if (itemData.use_percent) {
                itemBid = currentSpotPrice.bid * weigthOz * bidPremium;
                itemAsk = currentSpotPrice.ask * weigthOz * askPremium;
              } else {
                if (itemData.melt_plus) {
                  itemBid = currentSpotPrice.bid * weigthOz + bidPremium;
                  itemAsk = currentSpotPrice.ask * weigthOz + askPremium;
                } else {
                  itemBid = (currentSpotPrice.bid + bidPremium) * weigthOz;
                  itemAsk = (currentSpotPrice.ask + askPremium) * weigthOz;
                }
              }
            }
          }
        } else {
          console.log('PRICING DATA CHECK FAILED');
          console.log(itemData);
          console.log(currentSpotPrice);
        }

        if (itemBid && itemAsk) {
          var rnd = parseFloat(itemData.rounding);
          if (!isFinite(rnd) || rnd <= 0) {
            rnd = 0.01;
          }
          itemBid = Math.round(itemBid / rnd) * rnd;
          itemAsk = Math.ceil(itemAsk / rnd) * rnd;
        }
      } else {
        console.log('MISSING SPOT PRICE DATA');
        dataCheck = false;
      }

      return {
        bid: itemBid,
        ask: itemAsk
      };
    }
  }
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      authReady: false,
      quoteInterval: null,
      lastPriceCheck: null,
      quoteFetchInFlight: false,
      pendingForceRefresh: false
    };
  },

  methods: {
    hasValidSpotPrices: function hasValidSpotPrices(body) {
      return body && body.GOLD && body.SILV && body.PLAT && body.PALL;
    },
    finishSpotPriceFetch: function finishSpotPriceFetch() {
      this.quoteFetchInFlight = false;
      if (this.pendingForceRefresh) {
        this.getSpotPrices({ force: true });
      }
    },
    getSpotPrices: function getSpotPrices(options) {
      var _this = this;

      var force = !!(options && options.force);
      if (!this.$auth.check()) {
        return;
      }

      if (this.quoteFetchInFlight) {
        if (force) {
          this.pendingForceRefresh = true;
        }
        return;
      }
      if (!force && this.lastPriceCheck && Date.now() - this.lastPriceCheck < 5000) {
        return;
      }

      this.quoteFetchInFlight = true;
      this.pendingForceRefresh = false;
      this.$http.get('quote/all').then(function (response) {
        _this.lastPriceCheck = Date.now();
        if (_this.hasValidSpotPrices(response.body)) {
          _this.$bus.$emit('spot-price', response.body);
        }
        _this.finishSpotPriceFetch();
      }, function (response) {
        console.log(response);
        _this.finishSpotPriceFetch();
      });
    },
    userDetails: function userDetails() {
      var _this2 = this;

      if (this.$auth.check()) {
        this.$http.get('auth/userDetails').then(function (response) {
          if (response.body && response.body.message) {
            _this2.$router.push({ path: '/login' });
          }
        }, function (response) {
          console.log(response);
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getSpotPrices();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.quoteInterval = window.setInterval(function () {
      _this3.getSpotPrices();
      _this3.userDetails();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.quoteInterval);
  },
  created: function created() {
    var _this4 = this;

    if (this.$auth.ready()) {
      this.authReady = true;
    } else {
      this.$auth.ready(function () {
        _this4.authReady = true;
      });
    }

    this.$bus.$on('request-spot-price', function ($event) {
      _this4.getSpotPrices($event || {});
    });
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["f" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_pricing__ = __webpack_require__(22);






var emptySalesOrderMeta = function emptySalesOrderMeta() {
  return {
    reference_number: '',
    custodian: '',
    account_number: '',
    client_name: ''
  };
};

var emptyPurchaseOrderMeta = function emptyPurchaseOrderMeta() {
  return {
    reference_number: ''
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_pricing__["a" /* pricing */]],
  data: function data() {
    return {
      lock_items_buy: [],
      lock_items_sell: [],
      items_buy: [],
      items_sell: [],
      spot_prices: null,
      confirmScreen: false,
      successScreen: false,
      errorScreen: false,
      errorMessage: '',
      timerValue: 60,
      disabled: false,
      sites: [],
      sitePo: '',
      siteSo: '',
      salesOrderMeta: emptySalesOrderMeta(),
      purchaseOrderMeta: emptyPurchaseOrderMeta(),
      sellingLimitExceed: [],
      buyingLimitExceed: []
    };
  },

  watch: {
    timerValue: function timerValue(newVal, oldVal) {
      if (newVal === 0) {
        this.priceLockedItems();
        this.timerValue = 60;
      }
    },
    items_buy: function items_buy(newVal, oldVal) {
      console.log('newVal, oldVal', newVal, oldVal);
      this.priceItems();
    },
    items_sell: function items_sell(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  computed: {
    total_lock_buy: function total_lock_buy() {
      var total = 0.0;
      for (var i = 0; i < this.lock_items_buy.length; i++) {
        total += this.lock_items_buy[i].total;
      }
      return total;
    },
    total_lock_sell: function total_lock_sell() {
      var total = 0.0;
      for (var i = 0; i < this.lock_items_sell.length; i++) {
        total += this.lock_items_sell[i].total;
      }
      return total;
    },
    total_buy: function total_buy() {
      var total = 0.0;
      for (var i = 0; i < this.items_buy.length; i++) {
        total += this.items_buy[i].price_ask ? this.items_buy[i].quantity * this.items_buy[i].price_ask : 0;
      }
      return total;
    },
    total_sell: function total_sell() {
      var total = 0.0;
      for (var i = 0; i < this.items_sell.length; i++) {
        total += this.items_sell[i].price_bid ? this.items_sell[i].quantity * this.items_sell[i].price_bid : 0;
      }
      return total;
    }
  },
  methods: {
    isTruthyFlag: function isTruthyFlag(val) {
      return val === true || val === 1 || val === '1' || val === 'true';
    },
    availableQuantity: function availableQuantity(item) {
      var quantity = parseFloat(item.quantity_on_hand);
      return isFinite(quantity) ? quantity : 0;
    },
    quantityLimitValue: function quantityLimitValue(item, side) {
      if (this.isTruthyFlag(item.is_unlimited)) {
        return null;
      }
      if (this.isTruthyFlag(item.is_lc)) {
        var limitQuantity = parseFloat(item.limit_quantity);

        return isFinite(limitQuantity) ? limitQuantity : 0;
      }
      return side === 'so' ? this.availableQuantity(item) : null;
    },
    hasQuantityLimit: function hasQuantityLimit(item, side) {
      var limit = this.quantityLimitValue(item, side);
      return limit !== null && limit !== undefined && isFinite(limit);
    },
    quantityLimitLabel: function quantityLimitLabel(item, side) {
      var limit = this.quantityLimitValue(item, side);
      return limit === null || limit === undefined || !isFinite(limit) ? 'Unlimited' : limit;
    },
    exceedsQuantityLimit: function exceedsQuantityLimit(item, side) {
      var limit = this.quantityLimitValue(item, side);
      if (limit === null || limit === undefined || !isFinite(limit)) {
        return false;
      }
      return parseFloat(item.quantity) > limit;
    },
    onQuantityInput: function onQuantityInput(item, side) {
      var quantity = parseFloat(item.quantity);
      if (!isFinite(quantity) || quantity < 1) {
        item.quantity = 1;
      } else {
        var limit = this.quantityLimitValue(item, side);
        if (limit !== null && limit !== undefined && isFinite(limit) && quantity > limit) {
          item.quantity = limit > 0 ? limit : 1;
        }
      }
      this.priceItems();
    },
    rebuildExceedList: function rebuildExceedList(items, side) {
      var next = [];
      for (var i = 0; i < items.length; i++) {
        if (this.exceedsQuantityLimit(items[i], side)) {
          next.push(items[i].list_id);
        }
      }
      return next;
    },
    resetOrderMeta: function resetOrderMeta() {
      this.salesOrderMeta = emptySalesOrderMeta();
      this.purchaseOrderMeta = emptyPurchaseOrderMeta();
    },
    removeAllClose: function removeAllClose() {
      this.items_buy = [];
      this.items_sell = [];
      this.lock_items_buy = [];
      this.lock_items_sell = [];
      this.buyingLimitExceed = [];
      this.sellingLimitExceed = [];
      this.resetOrderMeta();
      document.body.classList.add('aside-menu-hidden');
    },
    removeBuyItem: function removeBuyItem(index) {
      var listId = this.items_buy[index].list_id;
      this.items_buy.splice(index, 1);
      this.buyingLimitExceed = this.buyingLimitExceed.filter(function (id) {
        return id !== listId;
      });
    },
    removeSellItem: function removeSellItem(index) {
      var listId = this.items_sell[index].list_id;
      this.items_sell.splice(index, 1);
      this.sellingLimitExceed = this.sellingLimitExceed.filter(function (id) {
        return id !== listId;
      });
    },
    executeOrder: function executeOrder() {
      var _this = this;

      var orderPayload = {
        purchase_orders: this.lock_items_sell,
        sales_orders: this.lock_items_buy,
        site_po: this.lock_items_sell.length ? this.sitePo : '',
        site_so: this.lock_items_buy.length ? this.siteSo : '',
        user: this.$auth.user()
      };

      if (this.lock_items_buy.length) {
        orderPayload.sales_order_metadata = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.salesOrderMeta);
      }

      if (this.lock_items_sell.length) {
        orderPayload.purchase_order_metadata = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.purchaseOrderMeta);
      }

      this.$http.post('order/execute', { order: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(orderPayload) }).then(function (response) {
        _this.items_buy = [];
        _this.items_sell = [];
        _this.lock_items_buy = [];
        _this.lock_items_sell = [];
        _this.resetOrderMeta();
        document.body.classList.add('aside-menu-hidden');
        _this.$bus.$emit('order-executed');
        var responseBody = response.body.status;
        if (responseBody === 'limit boundary error' || responseBody === 'validation error' || responseBody === 'failure') {
          _this.errorScreen = true;
          _this.errorMessage = response.body.message || 'Unable to complete the order.';
        } else {
          _this.successScreen = true;
        }
      }, function (response) {
        console.log(response);
      });
    },
    hasValidLockedPrices: function hasValidLockedPrices() {
      var allItems = this.items_buy.concat(this.items_sell);
      for (var i = 0; i < allItems.length; i++) {
        var price = parseFloat(allItems[i].price_ask || allItems[i].price_bid);
        if (!isFinite(price) || price <= 0) {
          return false;
        }
      }
      return allItems.length > 0;
    },
    lockAndConfirm: function lockAndConfirm() {
      this.priceItems();
      if (this.sellingLimitExceed.length > 0 || this.buyingLimitExceed.length > 0) {
        this.errorScreen = true;
        this.errorMessage = 'One or more items exceed the max quantity.';
        return;
      }
      if (!this.spot_prices) {
        this.errorScreen = true;
        this.errorMessage = 'Spot prices are still loading. Please wait a moment and try again.';
        return;
      }
      if (!this.hasValidLockedPrices()) {
        this.errorScreen = true;
        this.errorMessage = 'Prices are not available yet. Wait for spot prices to load, then try again.';
        return;
      }
      this.priceLockedItems();
      this.timerValue = 60;
      this.confirmScreen = true;
    },
    priceLockedItems: function priceLockedItems() {
      this.lock_items_buy = [];
      for (var i = 0; i < this.items_buy.length; i++) {
        this.lock_items_buy.push({
          list_id: this.items_buy[i].list_id,
          sales_desc: this.items_buy[i].sales_desc,
          quantity: this.items_buy[i].quantity > 0 ? this.items_buy[i].quantity : 1,
          price: this.items_buy[i].price_ask,
          total: (this.items_buy[i].quantity > 0 ? this.items_buy[i].quantity : 1) * this.items_buy[i].price_ask,
          limit_quantity: this.items_buy[i].limit_quantity,
          is_unlimited: this.items_buy[i].is_unlimited,
          is_lc: this.items_buy[i].is_lc,
          quantity_on_hand: this.items_buy[i].quantity_on_hand
        });
      }

      this.lock_items_sell = [];
      for (var j = 0; j < this.items_sell.length; j++) {
        this.lock_items_sell.push({
          list_id: this.items_sell[j].list_id,
          sales_desc: this.items_sell[j].sales_desc,
          quantity: this.items_sell[j].quantity > 0 ? this.items_sell[j].quantity : 1,
          price: this.items_sell[j].price_bid,
          total: (this.items_sell[j].quantity > 0 ? this.items_sell[j].quantity : 1) * this.items_sell[j].price_bid,
          limit_quantity: this.items_sell[j].limit_quantity,
          is_unlimited: this.items_sell[j].is_unlimited,
          is_lc: this.items_sell[j].is_lc,
          quantity_on_hand: this.items_sell[j].quantity_on_hand
        });
      }
    },
    formatPrice: function formatPrice(value) {
      if (value === null || value === undefined || !isFinite(value)) {
        return null;
      }
      return Number(value).toFixed(2);
    },
    priceItems: function priceItems() {
      for (var j = 0; j < this.items_buy.length; j++) {
        var buyCurrentPrice = this.priceItem(this.spot_prices, this.items_buy[j]);
        this.items_buy[j].price_bid = this.formatPrice(buyCurrentPrice.bid);
        this.items_buy[j].price_ask = this.formatPrice(buyCurrentPrice.ask);
        this.items_buy[j].total = this.items_buy[j].price_ask ? this.items_buy[j].quantity * this.items_buy[j].price_ask : null;
      }

      for (var i = 0; i < this.items_sell.length; i++) {
        var sellCurrentPrice = this.priceItem(this.spot_prices, this.items_sell[i]);
        this.items_sell[i].price_bid = this.formatPrice(sellCurrentPrice.bid);
        this.items_sell[i].price_ask = this.formatPrice(sellCurrentPrice.ask);
        this.items_sell[i].total = this.items_sell[i].price_bid ? this.items_sell[i].quantity * this.items_sell[i].price_bid : null;
      }

      this.buyingLimitExceed = this.rebuildExceedList(this.items_buy, 'so');
      this.sellingLimitExceed = this.rebuildExceedList(this.items_sell, 'po');
    },
    addItemSell: function addItemSell(itemData) {
      var newItem = true;

      for (var i = 0; i < this.items_sell.length; i++) {
        if (this.items_sell[i].list_id === itemData.list_id) {
          newItem = false;
        }
      }

      if (newItem) {
        this.items_sell.unshift({
          list_id: itemData.list_id,
          sales_desc: itemData.sales_desc,
          price_bid: itemData.price_bid.toFixed(2),
          WC_OZWT: itemData.WC_OZWT,
          premium_bid: itemData.premium_bid,
          premium_ask: itemData.premium_ask,
          pricing_type: itemData.pricing_type,
          use_percent: itemData.use_percent,
          melt_plus: itemData.melt_plus,
          rounding: itemData.rounding,
          quantity: 1,
          total: itemData.price_bid.toFixed(2),
          limit_quantity: itemData.lc_quantity,
          is_unlimited: itemData.is_unlimited,
          is_lc: itemData.is_lc,
          quantity_on_hand: itemData.quantity_on_hand,
          premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
          premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
        });
      }
    },
    addItemBuy: function addItemBuy(itemData) {
      var newItem = true;

      for (var i = 0; i < this.items_buy.length; i++) {
        if (this.items_buy[i].list_id === itemData.list_id) {
          newItem = false;
        }
      }

      if (newItem) {
        var askPrice = this.formatPrice(itemData.price_ask);
        this.items_buy.unshift({
          list_id: itemData.list_id,
          sales_desc: itemData.sales_desc,
          price_ask: askPrice,
          WC_OZWT: itemData.WC_OZWT,
          premium_bid: itemData.premium_bid,
          premium_ask: itemData.premium_ask,
          pricing_type: itemData.pricing_type,
          use_percent: itemData.use_percent,
          melt_plus: itemData.melt_plus,
          rounding: itemData.rounding,
          quantity: 1,
          total: askPrice,
          limit_quantity: itemData.lc_quantity,
          is_unlimited: itemData.is_unlimited,
          is_lc: itemData.is_lc,
          quantity_on_hand: itemData.quantity_on_hand,
          premium_bid_percentage: (itemData.premium_bid + '').split('.')[1],
          premium_ask_percentage: (itemData.premium_ask + '').split('.')[1]
        });
      }
    },
    getSites: function getSites() {
      var _this2 = this;

      this.$http.get('order/sites').then(function (response) {
        _this2.sites = response.body;
        _this2.disabled = _this2.sites.length ? _this2.disabled : !_this2.disabled;
        _this2.sitePo = _this2.sites.length ? _this2.sites[0].list_id : '';
        _this2.siteSo = _this2.sites.length ? _this2.sites[0].list_id : '';
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
    this.getSites();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.quoteInterval = window.setInterval(function () {
      _this3.timerValue--;
    }, 1000);
  },
  created: function created() {
    var _this4 = this;

    this.$bus.$on('buy-item', function ($event) {
      _this4.addItemBuy($event);
    });
    this.$bus.$on('sell-item', function ($event) {
      _this4.addItemSell($event);
    });
    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this4.spot_prices = $event;
      }
    });
  }
});

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  data: function data() {
    return {
      announcementStatus: 1
    };
  },

  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('logged out');
        },
        redirect: '/login'
      });
    },
    setting: function setting() {
      this.$router.push({ path: '/setting' });
    },
    showAnnouncement: function showAnnouncement() {
      this.$bus.$emit('show-announcement');
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this.announcementStatus = parseInt(response.body[1]['setting_value']);
        console.log('getAnnouncementDetails -> this.announcementStatus', _this.announcementStatus);
      }, function (response) {
        console.log(response);
      });
    }
  },
  created: function created() {
    this.getAnnouncementDetails();
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(149);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'announcement',
  data: function data() {
    return {
      announcementModal: false,
      announcementContent: ''
    };
  },

  methods: {
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this.announcementModal = true;
        _this.announcementContent = response.body[0]['setting_value'];
      }, function (response) {
        console.log(response);
      });
    },
    closeAnnouncement: function closeAnnouncement() {
      this.announcementModal = false;
      this.close();
    },
    close: function close() {
      console.log('close method called');
      this.$auth.user().is_update = 0;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('show-announcement', function ($event) {
      _this2.getAnnouncementDetails();
    });
  },
  beforeMount: function beforeMount() {
    console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update);

    if (this.$auth.user().is_update === 1) {
      this.userCheckedIn(this.$auth.user().id);
      this.getAnnouncementDetails();
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__["a" /* pricing */]],
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'inventory context',
      inventory_config: {
        showFav: true,
        showName: true,
        showWeight: true,
        showInStock: false,

        showOrdered: false,
        showSalesOrder: false,
        showPricing: false,
        showBid: false,
        showCost: false,
        showAsk: false,
        showBuy: true,
        showSell: true,
        pageSize: 10,
        customerFilter: true
      },
      featured: [],
      favorites: [],
      currentSpot: null,
      showInventory: false,
      showFeatured: false,
      showFavorite: true,
      announcementModal: false,
      announcementContent: ''
    };
  },

  watch: {
    favorites: function favorites(newVal, oldVal) {
      this.priceItems();
    },
    featured: function featured(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.featured[index]);
    },
    sellItem: function sellItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.featured[index]);
    },
    buyItemFav: function buyItemFav(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.favorites[index]);
    },
    sellItemFav: function sellItemFav(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.favorites[index]);
    },
    getFeatured: function getFeatured() {
      var _this = this;

      this.$http.get('inventory/featured').then(function (response) {
        _this.featured = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getFavorites: function getFavorites() {
      var _this2 = this;

      this.$http.get('inventory/favorites').then(function (response) {
        _this2.favorites = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.featured.length; i < len; i++) {
        var currentPrice = this.priceItem(this.currentSpot, this.featured[i]);
        this.featured[i].price_bid = currentPrice.bid;
        this.featured[i].price_ask = currentPrice.ask;
      }

      for (var j = 0, leng = this.favorites.length; j < leng; j++) {
        var _currentPrice = this.priceItem(this.currentSpot, this.favorites[j]);
        this.favorites[j].price_bid = _currentPrice.bid;
        this.favorites[j].price_ask = _currentPrice.ask;
      }
    },
    userCheckedIn: function userCheckedIn(id) {
      this.$http.post('auth/setUpdate', { 'id': id }).then(function (response) {
        console.log(response);
      }, function (response) {
        console.log(response);
      });
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this3 = this;

      console.log('getAnnouncementDetails -> getAnnouncementDetails');
      this.$http.get('admin/announcement-content').then(function (response) {
        _this3.announcementContent = response.body[0]['setting_value'];
        console.log('getAnnouncementDetails -> response.body', _this3.$auth.user());
      }, function (response) {
        console.log(response);
      });
    },
    closeAnnouncement: function closeAnnouncement() {
      this.announcementModal = false;
      this.close();
    },
    close: function close() {
      console.log('close method called');

      this.$auth.user().is_update = 0;
    }
  },
  created: function created() {
    var _this4 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this4.currentSpot = $event;
        _this4.priceItems();
      }
    });
    this.$bus.$on('favorite-item', function ($event) {
      _this4.getFavorites();
    });
  },
  beforeMount: function beforeMount() {
    this.getFeatured();
    this.getFavorites();
    this.$bus.$emit('request-spot-price');
    console.log('beforeMount -> this.$auth.user()', this.$auth.user().is_update);

    if (this.$auth.user().is_update === 1) {
      this.announcementModal = true;
      this.userCheckedIn(this.$auth.user().id);
      this.getAnnouncementDetails();
    } else {
      this.getAnnouncementDetails();
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(8);





var defaultFilters = function defaultFilters() {
  return {
    so_number: '',
    po_number: '',
    reference: '',
    custodian: '',
    account_number: '',
    client_name: '',
    order_type: ''
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderHistory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_pricing__["a" /* pricing */]],
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'order context',
      orderHistory: [],
      currentSpot: null,
      hasLoaded: false,
      filters: defaultFilters()
    };
  },

  filters: {
    formatMissing: function formatMissing(value) {
      if (!value) return '—';
      if (value === '') return '—';
      return value;
    }
  },
  watch: {
    orderHistory: function orderHistory(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.orderHistory[index]);
    },
    sellItem: function sellItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.orderHistory[index]);
    },
    buildQueryParams: function buildQueryParams() {
      var params = {};
      var keys = ['so_number', 'po_number', 'reference', 'custodian', 'account_number', 'client_name', 'order_type'];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (this.filters[key] && String(this.filters[key]).trim() !== '') {
          params[key] = String(this.filters[key]).trim();
        }
      }
      return params;
    },
    getOrderHistory: function getOrderHistory() {
      var _this = this;

      this.$http.get('order/history', { params: this.buildQueryParams() }).then(function (response) {
        _this.orderHistory = response.body;
        _this.hasLoaded = true;
      }, function (response) {
        console.log(response);
      });
    },
    searchOrders: function searchOrders() {
      this.getOrderHistory();
    },
    clearSearch: function clearSearch() {
      this.filters = defaultFilters();
      this.getOrderHistory();
    },
    formatStatus: function formatStatus(item) {
      if (item.status_label) {
        if (item.status_label === 'submitted') return 'Submitted';
        if (item.status_label === 'failed') return 'Failed';
        return 'Pending';
      }
      if (item.status === 1) return 'Submitted';
      if (item.status === -1) return 'Failed';
      return 'Pending';
    },
    displayReference: function displayReference(item) {
      if (item.reference_number) {
        return item.reference_number;
      }
      if (item.internal_reference) {
        return item.internal_reference;
      }
      return '—';
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.orderHistory.length; i < len; i++) {
        var currentPrice = this.priceItem(this.currentSpot, this.orderHistory[i]);
        this.orderHistory[i].price_bid = currentPrice.bid;
        this.orderHistory[i].price_ask = currentPrice.ask;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this2.currentSpot = $event;
        _this2.priceItems();
      }
    });
    this.$bus.$on('order-executed', function ($event) {
      _this2.getOrderHistory();
    });
  },
  beforeMount: function beforeMount() {
    this.getOrderHistory();
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'inventory context',
      inventory_config: {
        showName: true,
        showWeight: true,
        showInStock: true,
        showOrdered: true,
        showSalesOrder: true,
        showPricing: true,
        showBid: true,
        showCost: true,
        showAsk: true,
        showBuy: false,
        showSell: false,
        pageSize: 10,
        customerFilter: false
      }
    };
  },
  created: function created() {
    document.body.classList.add('aside-menu-hidden');
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      context: 'pricing context',
      adjustment: {
        gold_bid: 0.0,
        gold_ask: 0.0,
        silver_bid: 0.0,
        silver_ask: 0.0,
        palladium_bid: 0.0,
        palladium_ask: 0.0,
        platinum_bid: 0.0,
        platinum_ask: 0.0
      },
      successScreen: false,
      errorScreen: false
    };
  },

  methods: {
    savePrice: function savePrice() {
      var _this = this;

      this.$http.post('quote/adjust', this.adjustment).then(function (response) {
        _this.$bus.$emit('request-spot-price', { force: true });
        _this.successScreen = true;
      }, function (response) {
        console.log(response);
        _this.errorScreen = true;
      });
    },
    getAdjustments: function getAdjustments() {
      var _this2 = this;

      this.$http.get('quote/adjust', this.adjustment).then(function (response) {
        var adjData = JSON.parse(response.body);
        _this2.adjustment.gold_bid = adjData['gold_bid'];
        _this2.adjustment.gold_ask = adjData['gold_ask'];
        _this2.adjustment.silver_bid = adjData['silver_bid'];
        _this2.adjustment.silver_ask = adjData['silver_ask'];
        _this2.adjustment.palladium_bid = adjData['palladium_bid'];
        _this2.adjustment.palladium_ask = adjData['palladium_ask'];
        _this2.adjustment.platinum_bid = adjData['platinum_bid'];
        _this2.adjustment.platinum_ask = adjData['platinum_ask'];
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getAdjustments();
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'accountList',
  components: {
    Announcement: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Announcement */]
  },
  data: function data() {
    return {
      users: [],
      customers: [],
      vendors: [],
      currentUser: {},
      editScreen: false,
      resetMessage: '',
      resetError: false,
      isEditModeOn: false,
      deleteModal: false,
      storeDeleteModal: {},
      storeValueLimitModal: {},
      valueLimiterModal: false,
      modalLimit: {},
      freezeModal: false,
      storeFreezeModal: {},
      isGlobalFreeze: false
    };
  },

  methods: {
    newUser: function newUser() {
      this.currentUser = {};
      this.editScreen = true;
    },
    notifyWelcome: function notifyWelcome(index) {
      this.$http.post('admin/notify-welcome', this.users[index]).then(function (response) {
        console.log(response);
      }, function (response) {
        console.log(response);
      });
    },
    deleteIndex: function deleteIndex() {
      var _this = this;

      this.$toasted.show('Deleted User', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 500
      });
      this.$http.post('admin/user-delete', this.storeDeleteModal).then(function (response) {
        _this.getUsers();
      }, function (response) {
        console.log(response);
      });
    },
    toggleModel: function toggleModel(index) {
      this.deleteModal = true;
      this.storeDeleteModal = this.users[index];
    },
    saveUser: function saveUser(index) {
      var _this2 = this;

      this.resetError = false;
      this.resetMessage = '';

      index.preventDefault();
      var _currentUser = this.currentUser,
          name = _currentUser.name,
          email = _currentUser.email;

      if (name === undefined || name === null || email === undefined || email === null || (this.currentUser.change_password === undefined || this.currentUser.change_password === null) && !this.isEditModeOn || this.currentUser.customer_list_id === undefined || this.currentUser.customer_list_id === null || this.currentUser.vendor_list_id === undefined || this.currentUser.vendor_list_id === null) {
        this.resetMessage = 'All field are madatory !!';
        this.resetError = true;
      }

      if (this.resetError === false && !this.isEditModeOn && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
        this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.resetError = true;
      }

      if (this.isEditModeOn && this.currentUser.change_password && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
        this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.resetError = true;
      }
      if (this.resetError === false && this.currentUser.id) {
        this.editScreen = false;
        this.isEditModeOn = false;
        this.$http.post('admin/user-save', this.currentUser).then(function (response) {
          _this2.getUsers();
        }, function (response) {
          console.log(response);
        });
      } else if (this.resetError === false) {
        this.isEditModeOn = false;
        this.editScreen = false;
        this.$http.post('admin/user-create', this.currentUser).then(function (response) {
          _this2.getUsers();
        }, function (response) {
          console.log(response);
        });
      }
    },
    editUser: function editUser(index) {
      this.currentUser = this.users[index];
      this.editScreen = true;
      this.isEditModeOn = true;
    },
    getUsers: function getUsers() {
      var _this3 = this;

      this.$http.get('admin/users').then(function (response) {
        _this3.users = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getCustomers: function getCustomers() {
      var _this4 = this;

      this.$http.get('admin/customers').then(function (response) {
        _this4.customers = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    getVendors: function getVendors() {
      var _this5 = this;

      this.$http.get('admin/vendors').then(function (response) {
        _this5.vendors = response.body;
      }, function (response) {
        console.log(response);
      });
    },
    openValueLimiter: function openValueLimiter(index) {
      var _this6 = this;

      this.storeValueLimitModal = this.users[index];
      this.valueLimiterModal = true;
      this.$http.post('admin/user-limit-detail', this.storeValueLimitModal).then(function (response) {
        if (response && response.body && response.body.success) {
          _this6.modalLimit = {
            purchase: response.data.data.purchase_limit,
            sales: response.data.data.sales_limit,
            enable: response.data.data.is_limit_enabled
          };
        }
      }, function (response) {
        console.log('openValueLimiter -> response', response);
      });
    },
    setSuspended: function setSuspended(index) {
      var _this7 = this;

      console.log('setSuspended -> this.users[index]', this.users[index]);
      var textSus = this.users[index].is_suspended ? 'Suspended' : 'Unsuspended';
      this.$http.post('admin/user-suspended', this.users[index]).then(function (response) {
        _this7.getUsers();
        _this7.$toasted.show(textSus, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    saveValueLimiter: function saveValueLimiter() {
      var _this8 = this;

      this.valueLimiterModal = false;
      this.modalLimit.userId = this.storeValueLimitModal.id;
      this.modalLimit.purchase = this.modalLimit.purchase === '' ? 1 : this.modalLimit.purchase;
      this.modalLimit.sales = this.modalLimit.sales === '' ? 1 : this.modalLimit.sales;
      console.log('saveValueLimiter -> this.modalLimit', this.modalLimit);
      this.$http.post('admin/user-limit', this.modalLimit).then(function (response) {
        if (response && response.body && response.body.success) {
          _this8.$toasted.show('Value Limit setted successfully', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000
          });
        } else {
          _this8.$toasted.show('Please set the limit value again !!', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000
          });
        }
      }, function (response) {
        console.log(response);
      });
    },
    toggleFreezingModel: function toggleFreezingModel(index) {
      this.freezeModal = true;
      this.storeFreezeModal = this.users[index];
      this.freezeIndex();
    },
    freezeIndex: function freezeIndex() {
      var _this9 = this;

      this.$http.post('admin/user-freeze', this.storeFreezeModal).then(function (response) {
        console.log('freezeIndex -> this.storeFreezeModal.is_freeze', _this9.storeFreezeModal.is_freeze);
        var userFreezeText = _this9.storeFreezeModal.is_freeze === true ? 'Freeze' : 'Un-Freeze';
        _this9.$toasted.show(userFreezeText, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    toggleFreezeGlobal: function toggleFreezeGlobal() {
      var _this10 = this;

      this.$http.post('admin/global-freeze', { 'trade_freezing': this.isGlobalFreeze }).then(function (response) {
        var setFreezeText = _this10.isGlobalFreeze ? 'Freezed' : 'Unfreezed';
        _this10.$toasted.show(setFreezeText, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        });
      }, function (response) {
        console.log(response);
      });
    },
    getGlobalFreeze: function getGlobalFreeze() {
      var _this11 = this;

      this.$http.get('admin/global-freeze-details').then(function (response) {
        _this11.isGlobalFreeze = parseInt(response.body[0].setting_value);
      }, function (response) {
        console.log(response);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getUsers();
    this.getCustomers();
    this.getVendors();
    this.getGlobalFreeze();
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Setting',
  data: function data() {
    return {
      htmlForEditor: '',
      isChecked: false,
      isDraft: false,
      checkPreviewAnnouncement: false
    };
  },

  methods: {
    saveHtml: function saveHtml() {
      this.$toasted.show('Saved announcement', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 500
      });
      console.log('saveHtml -> htmlForEditor', this.htmlForEditor);
      this.$http.post('order/saveHtml', { 'content': this.htmlForEditor, 'mailOnEdit': this.isChecked, 'isDraft': this.isDraft }).then(function (response) {
        console.log('saveHtml -> response', response);
      }, function (response) {
        console.log(response);
      });
    },
    handleChangeCheck: function handleChangeCheck() {
      console.log('handleChangeCheck -> this.isChecked', this.isChecked);
    },
    getAnnouncementDetails: function getAnnouncementDetails() {
      var _this = this;

      this.$http.get('admin/announcement-content').then(function (response) {
        _this.htmlForEditor = response.body[0]['setting_value'];
        _this.isDraft = parseInt(response.body[1]['setting_value']);
        _this.isChecked = parseInt(response.body[2]['setting_value']);
      }, function (response) {
        console.log(response);
      });
    },
    toogleDraft: function toogleDraft() {},
    closePreviewAnnouncement: function closePreviewAnnouncement() {
      this.checkPreviewAnnouncement = false;
    },
    previewAccouncement: function previewAccouncement() {
      this.checkPreviewAnnouncement = true;
    }
  },
  beforeMount: function beforeMount() {
    this.getAnnouncementDetails();
  },

  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_0_vue2_editor__["a" /* VueEditor */],
    Announcement: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Announcement */]
  }
});

/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: ''
        },
        loginMessage: 'Sign in to your account.',
        loginError: false,
        forgetPage: false,
        forgetError: false,
        forgetMessage: 'Enter your e-mail address so we can send you a password reset request',
        showMailButton: true
      },
      error: null
    };
  },

  methods: {
    login: function login() {
      this.$auth.login({
        body: this.data.body,
        redirect: '/dashboard',
        success: function success(res) {
          console.log('success -> res.body.data', res.body.data);
          this.$auth.token(null, res.body.data.id);
          this.$auth.user(res.body.data);
        },
        error: function error(res) {
          this.data.loginError = true;
          this.data.loginMessage = res.body.message;
          this.$auth.logout();
        }
      });
    },
    forgetPassword: function forgetPassword() {
      var _this = this;

      this.data.showMailButton = false;
      this.data.forgetMessage = 'Enter your e-mail address so we can send you a password reset request';
      this.data.forgetError = false;
      if (this.data.body.username === null || this.data.body.username === '') {
        this.data.forgetError = true;
        this.data.forgetMessage = 'Please enter email Id.';
        this.data.showMailButton = true;
      } else {
        this.$http.post('auth/sendForgetMail', { 'username': this.data.body.username }).then(function (response) {
          if (response.body.message && response.body.message.message) {
            _this.data.forgetMessage = 'This e-mail address is not currently registered.';
            _this.data.forgetError = true;
            _this.data.showMailButton = true;
          }
        }, function (response) {
          console.log(response);
        });
      }
    },
    switchToLoginPage: function switchToLoginPage() {
      this.data.forgetPage = false;
    },
    switchToForgetPage: function switchToForgetPage() {
      this.data.forgetPage = true;
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: '',
          resetPassword: ''
        },
        resetMessage: 'Reset your Password.',
        resetError: false,
        isHttpRequest: true
      }
    };
  },

  methods: {
    resetPasswordFunc: function resetPasswordFunc() {
      var _this = this;

      this.data.resetError = false;
      this.data.resetMessage = 'Reset your Password.';
      this.data.isHttpRequest = true;
      console.log('resetPasswordFunc -> this.data.body', this.data.body);
      if (this.data.body.password === null || this.data.body.password === '' || this.data.body.resetPassword === null || this.data.body.resetPassword === '' || this.data.body.username === null || this.data.body.username === '') {
        this.data.resetError = true;
        this.data.resetMessage = 'Please enter all fields as they are mandatory.';
        this.data.isHttpRequest = false;
      }
      var _data$body = this.data.body,
          password = _data$body.password,
          resetPassword = _data$body.resetPassword,
          username = _data$body.username;

      if (this.data.resetError === false && (!password.match(/[a-z]/g) || !password.match(/[A-Z]/g) || !password.match(/[0-9]/g) || !password.match(/[^a-zA-Z\d]/g) || password.length <= 8)) {
        this.data.resetError = true;
        this.data.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.';
        this.data.isHttpRequest = false;
      }
      if (this.data.resetError === false && password !== resetPassword) {
        this.data.resetError = true;
        this.data.resetMessage = 'Both Password should be Same !!';
        this.data.isHttpRequest = false;
      }
      if (this.data.isHttpRequest) {
        console.log('resetPasswordFunc -> username', username);
        var requestBody = {
          'token_mail': this.$route.query.test,
          'email': username,
          'password_hash': password
        };
        this.$http.post('auth/setResetPassword', requestBody).then(function (response) {
          console.log(_this.$router, response);
          if (response && response.status === 200) {
            _this.$router.push({ path: '/login' });
          }
        }, function (response) {
          console.log(response);
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    console.log('The id is: ' + this.$route.params.id);
    this.$http.post('auth/getMailId', { 'token_mail': this.$route.query.test }).then(function (response) {
      if (response.status === 200 && response.body.user !== null && response.body.user !== undefined) {
        console.log('11001' + response);
        _this2.data.body.username = response.body.user;
      } else {
        _this2.data.resetError = true;
        _this2.data.resetMessage = response.body.message;
      }
    }, function (response) {
      console.log(response);
    });
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spot-prices',
  data: function data() {
    return {
      spot_prices: null,
      gold_color_bid: 'black',
      gold_color_ask: 'black',
      silver_color_bid: 'black',
      silver_color_ask: 'black',
      platinum_color_bid: 'black',
      platinum_color_ask: 'black',
      palladium_color_bid: 'black',
      palladium_color_ask: 'black'
    };
  },

  methods: {
    getColor: function getColor(newVal, oldVal) {
      if (oldVal && newVal > oldVal) {
        return 'green';
      } else if (oldVal && newVal < oldVal) {
        return 'red';
      } else {
        return 'black';
      }
    },

    currentSpotPrice: function currentSpotPrice(symbol) {
      if (this.spot_prices && this.spot_prices[symbol]) {
        return this.spot_prices[symbol];
      } else {
        return { bid: null, ask: null };
      }
    }
  },
  watch: {
    spot_prices: function spot_prices(newVal, oldVal) {
      if (oldVal) {
        this.gold_color_bid = this.getColor(newVal['GOLD'].bid, oldVal['GOLD'].bid);
        this.gold_color_ask = this.getColor(newVal['GOLD'].ask, oldVal['GOLD'].ask);
        this.silver_color_bid = this.getColor(newVal['SILV'].bid, oldVal['SILV'].bid);
        this.silver_color_ask = this.getColor(newVal['SILV'].ask, oldVal['SILV'].ask);
        this.platinum_color_bid = this.getColor(newVal['PLAT'].bid, oldVal['PLAT'].bid);
        this.platinum_color_ask = this.getColor(newVal['PLAT'].ask, oldVal['PLAT'].ask);
        this.palladium_color_bid = this.getColor(newVal['PALL'].bid, oldVal['PALL'].bid);
        this.palladium_color_ask = this.getColor(newVal['PALL'].ask, oldVal['PALL'].ask);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this.spot_prices = $event;
      }
    });
  },
  beforeMount: function beforeMount() {
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_pricing__ = __webpack_require__(22);




var DIRTY_TOGGLE_FIELDS = ['display', 'dns', 'dnb', 'feature', 'melt_plus', 'is_unlimited', 'is_lc', 'use_percent'];
var DIRTY_VALUE_FIELDS = ['lc_quantity', 'pricing_type', 'premium_bid', 'premium_ask', 'rounding'];
var DIRTY_FIELDS = DIRTY_TOGGLE_FIELDS.concat(DIRTY_VALUE_FIELDS);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_pricing__["a" /* pricing */]],
  props: {
    inventory_config: { default: null }
  },
  data: function data() {
    return {
      categories: [],
      categoryFilter: '',
      items: [],
      allItems: [],
      currentPage: 0,
      spot_prices: null,
      saveErrorScreen: false
    };
  },

  computed: {
    pages: function pages() {
      var currentPages = [];
      for (var i = 0; i < this.allItems.length / this.inventory_config.pageSize; i++) {
        currentPages.push({ name: i + 1, active: i === this.currentPage });
      }
      return currentPages;
    }
  },
  filters: {
    formatWeight: function formatWeight(value) {
      if (!value) return '';
      return parseFloat(value).toFixed(6);
    },
    formatMissing: function formatMissing(value) {
      if (!value) return '—';
      if (value === '') return '—';
      return value;
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      this.priceItems();
    },
    spot_prices: function spot_prices(newVal, oldVal) {
      this.priceItems();
    }
  },
  methods: {
    normalizeDirtyField: function normalizeDirtyField(field, value) {
      if (DIRTY_TOGGLE_FIELDS.indexOf(field) !== -1) {
        return value === true || value === 1 || value === '1' || value === 'true';
      }
      if (field === 'pricing_type') {
        return value == null ? '' : String(value);
      }
      var num = Number(value);
      return isNaN(num) ? value : num;
    },
    takeDirtySnapshot: function takeDirtySnapshot(item) {
      var snap = {};
      for (var i = 0; i < DIRTY_FIELDS.length; i++) {
        var field = DIRTY_FIELDS[i];
        snap[field] = this.normalizeDirtyField(field, item[field]);
      }
      return snap;
    },
    isItemDirty: function isItemDirty(item) {
      var snap = item._dirtySnapshot;
      if (!snap) {
        return false;
      }
      for (var i = 0; i < DIRTY_FIELDS.length; i++) {
        var field = DIRTY_FIELDS[i];
        if (this.normalizeDirtyField(field, item[field]) !== snap[field]) {
          return true;
        }
      }
      return false;
    },
    captureSnapshots: function captureSnapshots(items) {
      for (var i = 0; i < items.length; i++) {
        items[i]._dirtySnapshot = this.takeDirtySnapshot(items[i]);
        items[i].modified = false;
      }
    },
    syncDirty: function syncDirty(index) {
      this.items[index].modified = this.isItemDirty(this.items[index]);
    },
    onPricingFieldChange: function onPricingFieldChange(index) {
      this.calculatePricing(index);
      this.syncDirty(index);
    },
    favorite: function favorite(itemIndex) {
      var _this = this;

      this.$http.post('inventory/favorite', this.items[itemIndex]).then(function (response) {
        _this.$bus.$emit('favorite-item', _this.items[itemIndex]);
      }, function (response) {
        console.log(response);
      });
    },
    buyItem: function buyItem(index) {
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('buy-item', this.items[index]);
    },
    sellItem: function sellItem(index) {
      console.log('sellItem -> this.items[index]', this.items[index]);
      document.body.classList.remove('aside-menu-hidden');
      this.$bus.$emit('sell-item', this.items[index]);
    },
    setPage: function setPage(pageNum) {
      var maxPage = parseInt(this.allItems.length / this.inventory_config.pageSize);

      if (pageNum < 0) {
        this.currentPage = 0;
      } else if (pageNum > maxPage) {
        this.currentPage = maxPage;
      } else {
        this.currentPage = pageNum;
      }

      var pageStart = this.currentPage * this.inventory_config.pageSize;
      var pageEnd = pageStart + this.inventory_config.pageSize - 1;
      this.items = this.allItems.slice(pageStart, pageEnd);
    },
    getInventory: function getInventory() {
      var _this2 = this;

      this.$http.get('inventory/search', { params: { category: this.categoryFilter, customer: this.inventory_config.customerFilter } }).then(function (response) {
        _this2.allItems = response.body;
        _this2.captureSnapshots(_this2.allItems);
        _this2.items = _this2.allItems.slice(0, _this2.inventory_config.pageSize);
        _this2.currentPage = 0;
      }, function (response) {
        console.log(response);
      });
    },
    priceItems: function priceItems() {
      for (var i = 0, len = this.items.length; i < len; i++) {
        console.log('priceItems -> this.items[i]', this.items[i]);
        var currentPrice = this.priceItem(this.spot_prices, this.items[i]);
        this.items[i].price_bid = currentPrice.bid;
        this.items[i].price_ask = currentPrice.ask;
      }
    },
    calculatePricing: function calculatePricing(index) {
      console.log('calculatePricing -> index', index);
      var currentPrice = this.priceItem(this.spot_prices, this.items[index]);
      this.items[index].price_bid = currentPrice.bid;
      this.items[index].price_ask = currentPrice.ask;
    },
    saveItem: function saveItem(itemIndex) {
      var _this3 = this;

      this.$http.post('inventory/save', this.items[itemIndex]).then(function (response) {
        if (response.body && response.body.status === 'success') {
          _this3.items[itemIndex]._dirtySnapshot = _this3.takeDirtySnapshot(_this3.items[itemIndex]);
          _this3.items[itemIndex].modified = false;
        } else {
          _this3.items[itemIndex].modified = true;
          _this3.saveErrorScreen = true;
        }
      }, function (response) {
        console.log(response);
        _this3.items[itemIndex].modified = true;
        _this3.saveErrorScreen = true;
      });
    },
    onUnlimitedChange: function onUnlimitedChange(itemIndex) {
      if (this.items[itemIndex].is_unlimited) {
        this.items[itemIndex].is_lc = false;
      }
      this.syncDirty(itemIndex);
    },
    onQuantityLimitChange: function onQuantityLimitChange(itemIndex) {
      if (this.items[itemIndex].is_lc) {
        this.items[itemIndex].is_unlimited = false;
      }
      this.syncDirty(itemIndex);
    },
    getCategories: function getCategories() {
      var _this4 = this;

      this.$http.get('inventory/categories').then(function (response) {
        _this4.categories = response.body;
      }, function (response) {
        console.log(response);
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.$bus.$on('spot-price', function ($event) {
      if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
        _this5.spot_prices = $event;
        if (_this5.allItems.length === 0) {
          _this5.getInventory();
        }
      }
    });
  },
  beforeMount: function beforeMount() {
    this.getInventory();
    this.getCategories();
    this.$bus.$emit('request-spot-price');
  }
});

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_MarketFull__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_dashboard_Dashboard__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_orders_OrderHistory__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_inventory_Inventory__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_pricing_Pricing__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_users_Users__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_setting_Setting__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_login_Login__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_resetPassword_ResetPassword__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SpotPrices_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_InventoryList_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_toasted__);



























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('spot-prices', __WEBPACK_IMPORTED_MODULE_17__components_SpotPrices_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('inventory-list', __WEBPACK_IMPORTED_MODULE_18__components_InventoryList_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_toasted___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Metal Market',
    component: __WEBPACK_IMPORTED_MODULE_8__containers_MarketFull__["a" /* default */],
    redirect: '/dashboard',
    children: [{
      path: '/dashboard',
      meta: {
        auth: ['ADMIN', 'CUST']
      },
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_9__views_dashboard_Dashboard__["a" /* default */]
    }, {
      path: '/orders',
      meta: {
        auth: ['ADMIN', 'CUST']
      },
      name: 'OrderHistory',
      component: __WEBPACK_IMPORTED_MODULE_10__views_orders_OrderHistory__["a" /* default */]
    }, {
      path: '/inventory',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Inventory',
      component: __WEBPACK_IMPORTED_MODULE_11__views_inventory_Inventory__["a" /* default */]
    }, {
      path: '/pricing',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Pricing',
      component: __WEBPACK_IMPORTED_MODULE_12__views_pricing_Pricing__["a" /* default */]
    }, {
      path: '/users',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_13__views_users_Users__["a" /* default */]
    }, {
      path: '/setting',
      meta: {
        auth: ['ADMIN']
      },
      name: 'Setting',
      component: __WEBPACK_IMPORTED_MODULE_14__views_setting_Setting__["a" /* default */]
    }]
  }, {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_16__views_resetPassword_ResetPassword__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_15__views_login_Login__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/403',
    name: 'Unauthorized',
    redirect: '/login'
  }]
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router = router;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__webpack_require__(192), {
  auth: __webpack_require__(214),
  http: __webpack_require__(215),
  router: __webpack_require__(216)
});

if (false) {
  Vue.http.options.root = '';
}
if (true) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.root = 'https://metalmarket.place';
}
if (false) {
  Vue.http.options.root = 'http://test.metalmarket.place';
}
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.credentials = true;

var EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, {
  $bus: {
    get: function get() {
      return EventBus;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04894d0f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(91)
  __webpack_require__(93)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04894d0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04894d0f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authReady)?_c('router-view',{key:_vm.$route.path}):_c('div',{staticClass:"auth-loading"},[_vm._v("\n    Loading...\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketFull_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43179a6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketFull_vue__ = __webpack_require__(156);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketFull_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43179a6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketFull_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    roles: ['ADMIN', 'CUST']
  }, {
    name: 'Orders',
    url: '/orders',
    icon: 'icon-layers',
    roles: ['ADMIN', 'CUST']
  }, {
    name: 'Inventory',
    url: '/inventory',
    icon: 'icon-list',
    roles: ['ADMIN']
  }, {
    name: 'Pricing',
    url: '/pricing',
    icon: 'icon-settings',
    roles: ['ADMIN']
  }, {
    name: 'Users',
    url: '/users',
    icon: 'icon-people',
    roles: ['ADMIN']
  }, {
    name: 'Settings',
    url: '/setting',
    icon: 'icon-settings',
    roles: ['ADMIN']
  }]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4bcc27e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4bcc27e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane show fade active",attrs:{"role":"tabpanel","aria-hidden":"false","aria-expanded":"true"}},[_c('b-button',{staticClass:"btn btn-danger btn-lg btn-block",attrs:{"type":"button","variant":"info"},on:{"click":function($event){return _vm.lockAndConfirm()}}},[_vm._v("Lock Price & Confirm")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('div',{staticClass:"m-0 py-3 callout callout-success",staticStyle:{"border-bottom-width":"1px"}},[_c('div',[_vm._v("Buy Total: "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.total_buy)))])])]),_vm._v(" "),_c('div',{staticClass:"m-0 py-3 callout callout-primary"},[_c('div',[_vm._v("Sell Total: "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.total_sell)))])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._l((_vm.items_buy),function(item,index){return _c('div',{staticClass:"m-0 py-1 callout callout-success",staticStyle:{"border-bottom-width":"1px"}},[_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[_c('strong',[_vm._v(_vm._s(item.sales_desc))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[(_vm.exceedsQuantityLimit(item, 'so'))?_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Exceeds  ")]):_vm._e(),_vm._v("Max Quantity : "),_c('strong',[_vm._v(_vm._s(_vm.quantityLimitLabel(item, 'so')))])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",staticStyle:{"margin-bottom":"3px"},attrs:{"role":"group"}},[_vm._m(2,true),_vm._v(" "),(_vm.hasQuantityLimit(item, 'so'))?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"min":"1","max":_vm.quantityLimitValue(item, "so"),"type":"number"},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)},function($event){return _vm.onQuantityInput(item, 'so')}]}})]):_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"type":"number","name":"quantity","min":"1"},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)},function($event){return _vm.onQuantityInput(item, 'so')}]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeBuyItem(index)}}},[_c('i',{staticClass:"fa fa-remove"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"padding-bottom":"3px"}},[_c('small',[_vm._v(_vm._s(item.quantity)+" x "+_vm._s(_vm._f("currency")(item.price_ask))+" = "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.quantity * item.price_ask)))])])])])}),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_vm._l((_vm.items_sell),function(item,index){return _c('div',{staticClass:"m-0 py-1 callout callout-primary",staticStyle:{"border-bottom-width":"1px"}},[_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[_c('strong',[_vm._v(_vm._s(item.sales_desc))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"7px"}},[_c('small',[(_vm.exceedsQuantityLimit(item, 'po'))?_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Exceeds  ")]):_vm._e(),_vm._v("Max Quantity : "),_c('strong',[_vm._v(_vm._s(_vm.quantityLimitLabel(item, 'po')))])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",staticStyle:{"margin-bottom":"3px"},attrs:{"role":"group"}},[_vm._m(4,true),_vm._v(" "),(_vm.hasQuantityLimit(item, 'po'))?_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"min":"1","max":_vm.quantityLimitValue(item, "po"),"type":"number"},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)},function($event){return _vm.onQuantityInput(item, 'po')}]}})]):_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control form-control-sm col-sm-8 text-center",attrs:{"type":"number","name":"quantity","min":"1"},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)},function($event){return _vm.onQuantityInput(item, 'po')}]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeSellItem(index)}}},[_c('i',{staticClass:"fa fa-remove"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"padding-bottom":"3px"}},[_c('small',[_vm._v(_vm._s(item.quantity)+" x "+_vm._s(_vm._f("currency")(item.price_bid))+" = "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(item.quantity * item.price_bid)))])])])])}),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeAllClose()}}},[_c('i',{staticClass:"fa fa-remove"})])])],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Order Confirmation","size":"lg","ok-disabled":_vm.disabled,"ok-title":"Execute Order"},on:{"ok":function($event){return _vm.executeOrder()}},model:{value:(_vm.confirmScreen),callback:function ($$v) {_vm.confirmScreen=$$v},expression:"confirmScreen"}},[(_vm.lock_items_buy.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Prices locked for "+_vm._s(_vm.timerValue)+" seconds...")])])]):_vm._e(),_vm._v(" "),(_vm.lock_items_buy.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Sales Order")]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salesOrderMeta.reference_number),expression:"salesOrderMeta.reference_number"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Reference #","maxlength":"64"},domProps:{"value":(_vm.salesOrderMeta.reference_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.salesOrderMeta, "reference_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salesOrderMeta.custodian),expression:"salesOrderMeta.custodian"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Custodian","maxlength":"128"},domProps:{"value":(_vm.salesOrderMeta.custodian)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.salesOrderMeta, "custodian", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salesOrderMeta.account_number),expression:"salesOrderMeta.account_number"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Account #","maxlength":"64"},domProps:{"value":(_vm.salesOrderMeta.account_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.salesOrderMeta, "account_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salesOrderMeta.client_name),expression:"salesOrderMeta.client_name"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Client Name","maxlength":"128"},domProps:{"value":(_vm.salesOrderMeta.client_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.salesOrderMeta, "client_name", $event.target.value)}}})])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.lock_items_buy),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.sales_desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_ask)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.siteSo),expression:"siteSo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.siteSo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sites),function(site){return _c('option',{domProps:{"value":site.list_id}},[_vm._v(_vm._s(site.name))])}),0)]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"2"}},[_vm._v("Purchase Total:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total_lock_buy)))])])],2)])])]):_vm._e(),_vm._v(" "),(_vm.lock_items_sell.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Purchase Order")]),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.purchaseOrderMeta.reference_number),expression:"purchaseOrderMeta.reference_number"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Reference # (POID #)","maxlength":"64"},domProps:{"value":(_vm.purchaseOrderMeta.reference_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.purchaseOrderMeta, "reference_number", $event.target.value)}}})])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.lock_items_sell),function(item,index){return _c('tr',[_c('td',[_vm._v(_vm._s(item.sales_desc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_bid)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sitePo),expression:"sitePo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sitePo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sites),function(site){return _c('option',{domProps:{"value":site.list_id}},[_vm._v(_vm._s(site.name))])}),0)]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"2"}},[_vm._v("Sales Total:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total_lock_sell)))])])],2)])])]):_vm._e()]),_vm._v(" "),_c('b-modal',{staticClass:"modal-success",attrs:{"title":"Order Complete","ok-only":"","size":"sm","ok-title":"Close"},model:{value:(_vm.successScreen),callback:function ($$v) {_vm.successScreen=$$v},expression:"successScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h4',[_vm._v("Thank you!")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Order Incomplete","ok-only":"","size":"lg","ok-title":"Close"},model:{value:(_vm.errorScreen),callback:function ($$v) {_vm.errorScreen=$$v},expression:"errorScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v(_vm._s(_vm.errorMessage))])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("You Are Buying")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col-sm-5 text-right"},[_c('span',[_c('small',[_vm._v("Quantity :")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase callout"},[_c('small',[_c('b',[_vm._v("You Are Selling")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col-sm-5 text-right"},[_c('span',[_c('small',[_vm._v("Quantity:")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd076f3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd076f3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(47);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(113);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220177bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(115);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220177bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://www.wilshirecoin.com/"}},[_vm._v("Metal Market")]),_vm._v(" © 2020 WC3 LP")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"https://www.skyhoundinternet.com/"}},[_vm._v("Skyhound Internet")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetalMarketHeader_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12eb1bc6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetalMarketHeader_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MetalMarketHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12eb1bc6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetalMarketHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('div',[_vm._v(_vm._s(_vm.announcementStatus))]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarMinimize}},[_vm._v("☰")]),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[(_vm.announcementStatus === 0)?_c('span',{staticStyle:{"background-color":"#34383c","border-bottom":"1px solid #34383c","cursor":"pointer"},attrs:{"title":"Announcement"},on:{"click":_vm.showAnnouncement}},[_c('span',{staticStyle:{"color":"white"}},[_c('i',{staticClass:"fa fa-bell"})])]):_vm._e(),_vm._v(" \n    "),_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$auth.user().name))]),_vm._v(" "),_c('b-nav-item-dropdown',{staticClass:"avatar",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"/static/img/user.png","alt":""}})]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Account")])]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_vm._v("☰")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb09c44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(151);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdb09c44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(122);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89f823fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89f823fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c619eac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c619eac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(128);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(130);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416a7c73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(133);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_416a7c73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(148);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(150);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}),0)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[(_vm.$auth.check(item.roles))?_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1):_vm._e()]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(64);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(153);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcement_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7d16f9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Announcement_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Announcement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7d16f9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Announcement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement"},[_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){return _vm.closeAnnouncement()}},model:{value:(_vm.announcementModal),callback:function ($$v) {_vm.announcementModal=$$v},expression:"announcementModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.announcementContent)}})])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cabf8186_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cabf8186_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"15px"}},[_c('div',{staticClass:"col-xl-12"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showFavorite },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = false; _vm.showFeatured = false; _vm.showFavorite = true}}},[_vm._v("Favorites")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showFeatured },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = false; _vm.showFeatured = true; _vm.showFavorite = false}}},[_vm._v("Featured")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.showInventory },attrs:{"href":"#"},on:{"click":function($event){_vm.showInventory = true; _vm.showFeatured = false; _vm.showFavorite = false}}},[_vm._v("Inventory")])])])])]),_vm._v(" "),(_vm.showInventory)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('inventory-list',{attrs:{"inventory_config":_vm.inventory_config}})],1)]):_vm._e(),_vm._v(" "),(_vm.showFeatured)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.featured),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.sellItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n              ")]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.buyItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n              ")]):_vm._e()])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.showFavorite)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.favorites),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.sellItemFav(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n              ")]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.buyItemFav(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n                "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n              ")]):_vm._e()])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){return _vm.closeAnnouncement()}},model:{value:(_vm.announcementModal),callback:function ($$v) {_vm.announcementModal=$$v},expression:"announcementModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.announcementContent)}})])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Featured Item")]),_vm._v(" "),_c('th',[_vm._v("Net Ava.")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Favorite Item")]),_vm._v(" "),_c('th',[_vm._v("Net Ava.")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f814f58c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f814f58c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.so_number),expression:"filters.so_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"SO #"},domProps:{"value":(_vm.filters.so_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "so_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.po_number),expression:"filters.po_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"PO #"},domProps:{"value":(_vm.filters.po_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "po_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.reference),expression:"filters.reference"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Reference #"},domProps:{"value":(_vm.filters.reference)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "reference", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.custodian),expression:"filters.custodian"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Custodian"},domProps:{"value":(_vm.filters.custodian)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "custodian", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.account_number),expression:"filters.account_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Account #"},domProps:{"value":(_vm.filters.account_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "account_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.client_name),expression:"filters.client_name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Client Name"},domProps:{"value":(_vm.filters.client_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "client_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.order_type),expression:"filters.order_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "order_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("All Types")]),_vm._v(" "),_c('option',{attrs:{"value":"sales"}},[_vm._v("Sales Order")]),_vm._v(" "),_c('option',{attrs:{"value":"purchase"}},[_vm._v("Purchase Order")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"button"},on:{"click":_vm.searchOrders}},[_vm._v("Search")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearSearch}},[_vm._v("Clear")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.hasLoaded && _vm.orderHistory.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"15"}},[_vm._v("No orders found")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.orderHistory),function(item,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("moment")(item.order_created,'MM-DD-YYYY HH:mm')))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.formatStatus(item)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.purchase_desc))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.order_type))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatMissing")(item.so_number)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatMissing")(item.po_number)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.displayReference(item)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatMissing")(item.custodian)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatMissing")(item.account_number)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatMissing")(item.client_name)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.rate)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.total)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.sellItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_bid))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"})])]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n              Please Call\n            ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.buyItem(index)}}},[_vm._v("\n              "+_vm._s(_vm._f("currency")(item.price_ask))+"\n                "),_c('i',{staticClass:"fa fa-plus-circle"})])])])})],2)])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Item")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("SO #")]),_vm._v(" "),_c('th',[_vm._v("PO #")]),_vm._v(" "),_c('th',[_vm._v("Reference")]),_vm._v(" "),_c('th',[_vm._v("Custodian")]),_vm._v(" "),_c('th',[_vm._v("Account #")]),_vm._v(" "),_c('th',[_vm._v("Client Name")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Bid")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6725af71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6725af71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('inventory-list',{attrs:{"inventory_config":_vm.inventory_config}}),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e46728e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__(166);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e46728e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Gold")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.gold_bid),expression:"adjustment.gold_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.gold_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "gold_bid", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.gold_ask),expression:"adjustment.gold_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.gold_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "gold_ask", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Silver")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.silver_bid),expression:"adjustment.silver_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.silver_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "silver_bid", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.silver_ask),expression:"adjustment.silver_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.silver_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "silver_ask", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Platinum")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.platinum_bid),expression:"adjustment.platinum_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.platinum_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "platinum_bid", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.platinum_ask),expression:"adjustment.platinum_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.platinum_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "platinum_ask", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"align-right"},[_vm._v("Palladium")]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.palladium_bid),expression:"adjustment.palladium_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.palladium_bid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "palladium_bid", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adjustment.palladium_ask),expression:"adjustment.palladium_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(_vm.adjustment.palladium_ask)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adjustment, "palladium_ask", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.savePrice()}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v("  Save Price Adjustment")])]),_vm._v(" "),_c('announcement'),_vm._v(" "),_c('b-modal',{staticClass:"modal-success",attrs:{"title":"Adjustment Saved","ok-only":"","size":"sm","ok-title":"Close"},model:{value:(_vm.successScreen),callback:function ($$v) {_vm.successScreen=$$v},expression:"successScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Price adjustment saved. Live prices are refreshing.")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Save Failed","ok-only":"","size":"sm","ok-title":"Close"},model:{value:(_vm.errorScreen),callback:function ($$v) {_vm.errorScreen=$$v},expression:"errorScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Unable to save price adjustment. Please try again.")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Metal")]),_vm._v(" "),_c('th',[_vm._v("Bid")]),_vm._v(" "),_c('th',[_vm._v("Ask")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30da3422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30da3422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.newUser()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("  New User")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-6",staticStyle:{"font-weight":"bold"}},[_vm._v("Freeze Trading Globally")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isGlobalFreeze),expression:"isGlobalFreeze"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isGlobalFreeze)?_vm._i(_vm.isGlobalFreeze,null)>-1:(_vm.isGlobalFreeze)},on:{"change":[function($event){var $$a=_vm.isGlobalFreeze,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isGlobalFreeze=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isGlobalFreeze=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isGlobalFreeze=$$c}},function($event){return _vm.toggleFreezeGlobal()}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[(user.role == 'ADMIN')?_c('span',[_vm._v("Administrator")]):_vm._e(),_vm._v(" "),(user.role == 'CUST')?_c('span',[_vm._v("Customer")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.customer_name))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(user.vendor_name))]),_vm._v(" "),_c('td',[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(user.is_suspended),expression:"user.is_suspended"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(user.is_suspended)?_vm._i(user.is_suspended,null)>-1:(user.is_suspended)},on:{"change":[function($event){var $$a=user.is_suspended,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(user, "is_suspended", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(user, "is_suspended", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(user, "is_suspended", $$c)}},function($event){return _vm.setSuspended(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.openValueLimiter(index)}}},[_vm._v("Value Limiter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.editUser(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"width":"100px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.notifyWelcome(index)}}},[_vm._v("Welcome")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"width":"40px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleModel(index)}}},[_c('i',{staticClass:"fa fa-times"})])])])}),0)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary user-edit",attrs:{"title":"User","ok-title":"Save"},on:{"ok":_vm.saveUser},model:{value:(_vm.editScreen),callback:function ($$v) {_vm.editScreen=$$v},expression:"editScreen"}},[_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.resetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.name),expression:"currentUser.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"User Name"},domProps:{"value":(_vm.currentUser.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-envelope"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.email),expression:"currentUser.email"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Email Address"},domProps:{"value":(_vm.currentUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-asterisk"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.change_password),expression:"currentUser.change_password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.currentUser.change_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "change_password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user-circle"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.customer_list_id),expression:"currentUser.customer_list_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentUser, "customer_list_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.customers),function(customer,index){return _c('option',{domProps:{"value":customer.list_id}},[_vm._v(_vm._s(customer.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-user-circle-o"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.vendor_list_id),expression:"currentUser.vendor_list_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentUser, "vendor_list_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.vendors),function(vendor,index){return _c('option',{domProps:{"value":vendor.list_id}},[_vm._v(_vm._s(vendor.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-row b-form-group form-group",attrs:{"role":"group"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group",attrs:{"role":"group"}},[_c('div',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-lock"})]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.role),expression:"currentUser.role"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.currentUser, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"ADMIN"}},[_vm._v("Administrator")]),_vm._v(" "),_c('option',{attrs:{"value":"CUST"}},[_vm._v("Customer")])])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"none"},attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_c('span')])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Delete User","ok-title":"Delete","ok-only":"","size":"sm"},on:{"ok":function($event){return _vm.deleteIndex()}},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Are you sure you want to delete ?")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Value Limiter","ok-title":"Save","ok-only":"","size":"lg"},on:{"ok":function($event){return _vm.saveValueLimiter()}},model:{value:(_vm.valueLimiterModal),callback:function ($$v) {_vm.valueLimiterModal=$$v},expression:"valueLimiterModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Set the value limiter for the account of "+_vm._s(_vm.storeValueLimitModal.name)+".")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('thead',[_c('tr',[_c('th',{staticClass:"align-center"},[_vm._v("Sales Credit Limit")]),_vm._v(" "),_c('th',{staticClass:"align-middle"},[_vm._v("Purchase Credit Limit")]),_vm._v(" "),_c('th',{staticClass:"align-middle"},[_vm._v("Enable")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.purchase),expression:"modalLimit.purchase"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"type":"number","min":"1","oninput":"validity.valid||(value='1')"},domProps:{"value":(_vm.modalLimit.purchase)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modalLimit, "purchase", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.sales),expression:"modalLimit.sales"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"type":"number","min":"1","oninput":"validity.valid||(value='1')"},domProps:{"value":(_vm.modalLimit.sales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modalLimit, "sales", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('label',{staticClass:"switch switch-3d switch-icon switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalLimit.enable),expression:"modalLimit.enable"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.modalLimit.enable)?_vm._i(_vm.modalLimit.enable,null)>-1:(_vm.modalLimit.enable)},on:{"change":function($event){var $$a=_vm.modalLimit.enable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.modalLimit, "enable", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.modalLimit, "enable", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.modalLimit, "enable", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Customer")]),_vm._v(" "),_c('th',[_vm._v("Vendor")]),_vm._v(" "),_c('th',[_vm._v("Suspended")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea8e322_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ea8e322_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row col-12",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-6",staticStyle:{"font-weight":"bold"}},[_vm._v("\n      Broadcast Announcement Message\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row col-12"},[_c('div',{staticClass:"col-2",staticStyle:{"font-weight":"bold"}},[_vm._v("Status: ")]),_vm._v(" "),_c('div',{staticClass:"col-9 row"},[_c('div',[_vm._v("ON")]),_vm._v(" \n          "),_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isDraft),expression:"isDraft"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isDraft)?_vm._i(_vm.isDraft,null)>-1:(_vm.isDraft)},on:{"change":[function($event){var $$a=_vm.isDraft,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isDraft=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isDraft=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isDraft=$$c}},function($event){return _vm.toogleDraft()}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})]),_vm._v(" \n          "),_c('div',[_vm._v("OFF")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('vue-editor',{attrs:{"id":"editor"},model:{value:(_vm.htmlForEditor),callback:function ($$v) {_vm.htmlForEditor=$$v},expression:"htmlForEditor"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"20px","padding-right":"15px"}},[_c('div',{staticClass:"col-xl-6"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_c('tbody',[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"align-middle text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isChecked),expression:"isChecked"}],staticStyle:{"padding":"15px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isChecked)?_vm._i(_vm.isChecked,null)>-1:(_vm.isChecked)},on:{"change":[function($event){var $$a=_vm.isChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isChecked=$$c}},_vm.handleChangeCheck]}})])])])])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.previewAccouncement()}}},[_vm._v("Preview Announcement")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveHtml()}}},[_vm._v("Save")])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Preview Announcement - Metal Market","ok-only":"","size":"lg"},on:{"ok":function($event){return _vm.closePreviewAnnouncement()}},model:{value:(_vm.checkPreviewAnnouncement),callback:function ($$v) {_vm.checkPreviewAnnouncement=$$v},expression:"checkPreviewAnnouncement"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',[_vm._v("Preview New Updates")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.htmlForEditor)}})])])])])])])]),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"align-middle text-center"},[_c('div',[_vm._v("E-mail notification to users")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14d55de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14d55de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[(!_vm.data.forgetPage)?_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.loginError, 'error-text': _vm.data.loginError }},[_vm._v(_vm._s(_vm.data.loginMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.data.body.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.login()}}},[_vm._v("Login")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-link px-0",attrs:{"type":"button"},on:{"click":function($event){return _vm.switchToForgetPage()}}},[_vm._v("Forgot password?")])])])]):_vm._e(),_vm._v(" "),(_vm.data.forgetPage)?_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Forget Password")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.forgetError, 'error-text': _vm.data.forgetError }},[_vm._v(_vm._s(_vm.data.forgetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.data.showMailButton)?_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.forgetPassword()}}},[_vm._v("Send Mail")])]):_vm._e(),_vm._v(" "),(_vm.data.showMailButton)?_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-link px-0",attrs:{"type":"button"},on:{"click":function($event){return _vm.switchToLoginPage()}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!_vm.data.showMailButton)?_c('div',[_vm._m(3)]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_vm._m(4)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"success-text"},[_vm._v("An email has been sent with instructions on how to reset your password. It may take a few minutes to arrive. If you do not receive it, please check your spam filter.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-dark py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(181)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = "/static/img/wc.17bc451.png";

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b1476e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b1476e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{key:_vm.$route.params.id,staticClass:"card-body"},[_c('h1',[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{class:{ 'text-muted': !_vm.data.resetError, 'error-text': _vm.data.resetError }},[_vm._v(_vm._s(_vm.data.resetMessage))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"disabled":"","type":"text","placeholder":"Email"},domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.data.body.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.resetPassword),expression:"data.body.resetPassword"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Reset Password"},domProps:{"value":(_vm.data.body.resetPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "resetPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetPasswordFunc()}}},[_vm._v("Reset Password")])])])])]),_vm._v(" "),_vm._m(3)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-dark py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(185)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "/static/img/wc.17bc451.png";

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotPrices_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe4ab58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpotPrices_vue__ = __webpack_require__(187);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotPrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe4ab58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpotPrices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#EEE8AA","width":"110px"}},[_vm._v("Gold")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.gold_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('GOLD').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.gold_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('GOLD').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#BCC6CC","width":"110px"}},[_vm._v("Silver")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.silver_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('SILV').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.silver_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('SILV').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#E5E4E2","width":"110px"}},[_vm._v("Platinum")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.platinum_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PLAT').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.platinum_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PLAT').ask)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('table',{staticClass:"table table-bordered table-striped table-sm"},[_c('tr',[_c('th',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#CED0DD","width":"110px"}},[_vm._v("Palladium")]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.palladium_color_bid })},[_vm._v("Bid:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PALL').bid)))]),_vm._v(" "),_c('td',{staticClass:"align-middle text-center",staticStyle:{"background-color":"#FFFFFF"},style:({ 'color': _vm.palladium_color_ask })},[_vm._v("Ask:"),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.currentSpotPrice('PALL').ask)))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdef4fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdef4fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryFilter),expression:"categoryFilter"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getInventory()}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Categories")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{domProps:{"value":category.value}},[(category.level === 2)?_c('p',[_vm._v("  •")]):_vm._e(),_vm._v(" "),(category.level === 3)?_c('p',[_vm._v("      ▸")]):_vm._e(),_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-9"},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.setPage(_vm.currentPage - 1)}}},[_vm._v("Prev")])]),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('li',{staticClass:"page-item",class:{ active: page.active }},[(index >= _vm.currentPage - 5 && (index < _vm.currentPage + 5 || index < 10))?_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.setPage(index)}}},[_vm._v(_vm._s(page.name))]):_vm._e()])}),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.setPage(_vm.currentPage + 1)}}},[_vm._v("Next")])])],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 row flex-row flex-nowrap"},[_c('table',{staticClass:"table table-bordered table-striped table-sm table-text-no-wrap"},[_c('thead',[_c('tr',[(_vm.inventory_config.showFav)?_c('th',[_vm._v("Fav")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showName)?_c('th',[_vm._v("Item Name")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('th',[_vm._v("Wgt (oz)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showInStock)?_c('th',[_vm._v("Avail")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showOrdered)?_c('th',[_vm._v("Ord")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('th',[_vm._v("SO")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('th',[_vm._v("Net Ava.")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Show")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("DNS")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("DNB")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Feat")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Melt+")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("UQ∞")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("QL")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("QTY (QL)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Pricing")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Bid (Prm)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Ask (Prm)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',{staticClass:"text-center"},[_vm._v("%")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th',[_vm._v("Round")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBid)?_c('th',{staticClass:"text-right"},[_vm._v("Bid (Price)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showCost)?_c('th',{staticClass:"text-right"},[_vm._v("Avg Cost")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showAsk)?_c('th',{staticClass:"text-right"},[_vm._v("Ask (Price)")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('th'):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBuy)?_c('th',{staticClass:"text-center"},[_vm._v("Bid")]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSell)?_c('th',{staticClass:"text-center"},[_vm._v("Ask")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',[(_vm.inventory_config.showFav)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-icon switch-primary",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.fav),expression:"item.fav"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.fav)?_vm._i(item.fav,null)>-1:(item.fav)},on:{"change":[function($event){var $$a=item.fav,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "fav", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "fav", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "fav", $$c)}},function($event){return _vm.favorite(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showName)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.sales_desc))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("formatWeight")(item.WC_OZWT)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showWeight)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showOrdered)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_sales_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSalesOrder)?_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(item.quantity_on_hand + item.quantity_on_order -item.quantity_on_sales_order))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.display),expression:"item.display"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.display)?_vm._i(item.display,null)>-1:(item.display)},on:{"change":[function($event){var $$a=item.display,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "display", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "display", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "display", $$c)}},function($event){return _vm.syncDirty(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.dns),expression:"item.dns"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.dns)?_vm._i(item.dns,null)>-1:(item.dns)},on:{"change":[function($event){var $$a=item.dns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "dns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "dns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "dns", $$c)}},function($event){return _vm.syncDirty(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-danger",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.dnb),expression:"item.dnb"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.dnb)?_vm._i(item.dnb,null)>-1:(item.dnb)},on:{"change":[function($event){var $$a=item.dnb,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "dnb", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "dnb", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "dnb", $$c)}},function($event){return _vm.syncDirty(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-primary",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.feature),expression:"item.feature"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.feature)?_vm._i(item.feature,null)>-1:(item.feature)},on:{"change":[function($event){var $$a=item.feature,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "feature", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "feature", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "feature", $$c)}},function($event){return _vm.syncDirty(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-dark",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.melt_plus),expression:"item.melt_plus"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.melt_plus)?_vm._i(item.melt_plus,null)>-1:(item.melt_plus)},on:{"change":[function($event){var $$a=item.melt_plus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "melt_plus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "melt_plus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "melt_plus", $$c)}},function($event){return _vm.onPricingFieldChange(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.is_unlimited),expression:"item.is_unlimited"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.is_unlimited)?_vm._i(item.is_unlimited,null)>-1:(item.is_unlimited)},on:{"change":[function($event){var $$a=item.is_unlimited,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "is_unlimited", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "is_unlimited", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "is_unlimited", $$c)}},function($event){return _vm.onUnlimitedChange(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('label',{staticClass:"switch switch-3d switch-success",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.is_lc),expression:"item.is_lc"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.is_lc)?_vm._i(item.is_lc,null)>-1:(item.is_lc)},on:{"change":[function($event){var $$a=item.is_lc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "is_lc", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "is_lc", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "is_lc", $$c)}},function($event){return _vm.onQuantityLimitChange(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.lc_quantity),expression:"item.lc_quantity",modifiers:{"number":true}}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},attrs:{"min":"0","type":"number"},domProps:{"value":(item.lc_quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "lc_quantity", _vm._n($event.target.value))},function($event){return _vm.syncDirty(index)}],"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.pricing_type),expression:"item.pricing_type"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "pricing_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onPricingFieldChange(index)}]}},[_c('option',{attrs:{"value":"FIX"}},[_vm._v("Fixed")]),_vm._v(" "),_c('option',{attrs:{"value":"GOLD"}},[_vm._v("Gold")]),_vm._v(" "),_c('option',{attrs:{"value":"SILV"}},[_vm._v("Silver")]),_vm._v(" "),_c('option',{attrs:{"value":"PLAT"}},[_vm._v("Platinum")]),_vm._v(" "),_c('option',{attrs:{"value":"PALL"}},[_vm._v("Palladium")])])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.premium_bid),expression:"item.premium_bid"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(item.premium_bid)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "premium_bid", $event.target.value)},function($event){return _vm.onPricingFieldChange(index)}]}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.premium_ask),expression:"item.premium_ask"}],staticClass:"form-control text-right form-control-sm",staticStyle:{"width":"80px"},domProps:{"value":(item.premium_ask)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "premium_ask", $event.target.value)},function($event){return _vm.onPricingFieldChange(index)}]}})]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle text-center"},[_c('label',{staticClass:"switch switch-text switch-dark",staticStyle:{"margin-bottom":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.use_percent),expression:"item.use_percent"}],staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.use_percent)?_vm._i(item.use_percent,null)>-1:(item.use_percent)},on:{"change":[function($event){var $$a=item.use_percent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "use_percent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "use_percent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "use_percent", $$c)}},function($event){return _vm.onPricingFieldChange(index)}]}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"%","data-off":"$"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.rounding),expression:"item.rounding"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "rounding", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onPricingFieldChange(index)}]}},[_c('option',{attrs:{"value":"0.01"}},[_vm._v(".01")]),_vm._v(" "),_c('option',{attrs:{"value":"0.05"}},[_vm._v(".05")]),_vm._v(" "),_c('option',{attrs:{"value":"0.1"}},[_vm._v(".10")]),_vm._v(" "),_c('option',{attrs:{"value":"0.25"}},[_vm._v(".25")]),_vm._v(" "),_c('option',{attrs:{"value":"0.5"}},[_vm._v(".50")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1.00")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5.00")])])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBid)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_bid)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showCost)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("formatMissing")(_vm._f("currency")(item.average_cost))))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showAsk)?_c('td',{staticClass:"align-middle text-right"},[_vm._v(_vm._s(_vm._f("currency")(item.price_ask)))]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showPricing)?_c('td',{staticClass:"align-middle text-right"},[(item.modified)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveItem(index)}}},[_vm._v("Save")]):_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"type":"button","disabled":true}},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showBuy)?_c('td',{staticClass:"align-middle text-center"},[(item.dnb)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n            Please Call\n          ")]):_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.sellItem(index)}}},[_vm._v("\n            "+_vm._s(_vm._f("currency")(item.price_bid))+"\n              "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n              "+_vm._s((Math.sign(item.premium_bid)  === 1 || item.premium_bid === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_bid))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+" \n            ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.inventory_config.showSell)?_c('td',{staticClass:"align-middle text-center"},[(item.dns)?_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"}},[_vm._v("\n            Please Call\n          ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"140px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.buyItem(index)}}},[_vm._v("\n            "+_vm._s(_vm._f("currency")(item.price_ask))+"\n              "),_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('br'),_vm._v(" "),(item.use_percent === 0)?_c('span',[_vm._v("\n              "+_vm._s((Math.sign(item.premium_ask)  === 1 || item.premium_ask === 0) ?'+':'-')+_vm._s('$' + Math.abs(item.premium_ask))+" "+_vm._s(item.melt_plus ? ' per piece' : ' per ounce')+"\n            ")]):_vm._e()])]):_vm._e()])}),0)])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Save Failed","ok-only":"","size":"sm","ok-title":"Close"},model:{value:(_vm.saveErrorScreen),callback:function ($$v) {_vm.saveErrorScreen=$$v},expression:"saveErrorScreen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h6',[_vm._v("Unable to save item. Please try again.")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[79]);


// WEBPACK FOOTER //
// static/js/app.c99b30ac02b7cb5ff014.js